import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { PanelOriginStruct } from "../../structs/panel/panel-origin.struct";

export class GetPanelResponse extends ReturnStruct {
    public idPanel: number | null = null;
    public idLayout: number | null = null;
    public idHealthUnit: number | null = null;
    public incorrectPinCount: number | null = null;
    
    public pin: string = '';
    public panelName: string = '';
    public description: string = '';
    public imgString64: string = '';
    public panelVideoName: string = '';
    public token: string = '';
    public videoFormat: string = '';
    public primaryColorCode: string = '';
    public secundaryColorCode: string = '';

    public isActive: boolean = false;
    public isLogoUploaded: boolean = false;
    public callByPassword: boolean = false;
    public useColor: boolean = false;

    public listPanelOrigin: PanelOriginStruct[] = [];
}